import makeStyles from "@material-ui/styles/makeStyles";

const styles = makeStyles(theme => ({
	wrapper: {
		marginTop: theme.spacing(4)
	}
}));

export default styles;
